export default {
  35 : {
    250 : {
      '0.3-0.4' : { 1 : '8', 2 : '16', 4 : 'nelze', 8 : 'nelze', 10 : 'nelze', 12 : 'nelze', 14 : 'nelze', 18 : 'nelze', 20 : 'nelze' },
      '0.6' : {1 : '2', 2 : '4', 4 : '7', 8 : '13', 10 : '16', 12 : '19', 14 : '22', 18 : '28', 20 : 'nelze'},
    },
    500 : {
      '0.3-0.4' : {1 : '4', 2 : '8', 4 : '16', 8 : 'nelze', 10 : 'nelze', 12 : 'nelze', 14 : 'nelze', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '4', 8 : '7', 10 : '8', 12 : '10', 14 : '11', 18 : '14', 20 : '16'},
    },
    750 : {
      '0.3-0.4' : {1 : '3', 2 : '6', 4 : '11', 8 : '21', 10 : '26', 12 : 'nelze', 14 : 'nelze', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '3', 8 : '5', 10 : '6', 12 : '7', 14 : '8', 18 : '10', 20 : '11'},
    },
    1000 : {
      '0.3-0.4' : {1 : '2', 2 : '4', 4 : '8', 8 : '16', 10 : '20', 12 : '24', 14 : '28', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '2', 8 : '4', 10 : '4', 12 : '5', 14 : '6', 18 : '7', 20 : '8'},
    },
  },
  60 : {
    250 : {
      '0.3-0.4' : {1 : '6', 2 : '11', 4 : '21', 8 : 'nelze', 10 : 'nelze', 12 : 'nelze', 14 : 'nelze', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '3', 4 : '5', 8 : '9', 10 : '11', 12 : '13', 14 : '15', 18 : '19', 20 : '21'},
    },
    500 : {
      '0.3-0.4' : {1 : '3', 2 : '6', 4 : '11', 8 : '21', 10 : '26', 12 : 'nelze', 14 : 'nelze', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '3', 8 : '5', 10 : '6', 12 : '7', 14 : '8', 18 : '10', 20 : '11'},
    },
    750 : {
      '0.3-0.4' : {1 : '2', 2 : '4', 4 : '7', 8 : '14', 10 : '18', 12 : '21', 14 : '24', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '2', 8 : '3', 10 : '4', 12 : '5', 14 : '5', 18 : '7', 20 : '7'},
    },
    1000 : {
      '0.3-0.4' : {1 : '2', 2 : '3', 4 : '6', 8 : '11', 10 : '13', 12 : '16', 14 : '18', 18 : '24', 20 : '26'},
      '0.6' : {1 : '2', 2 : '2', 4 : '2', 8 : '3', 10 : '3', 12 : '4', 14 : '4', 18 : '5', 20 : '6'},
    },
  },
  90 : {
    250 : {
      '0.3-0.4' : {1 : '5', 2 : '9', 4 : '18', 8 : 'nelze', 10 : 'nelze', 12 : 'nelze', 14 : 'nelze', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '4', 8 : '8', 10 : '9', 12 : '11', 14 : '13', 18 : '18', 20 : '18'},
    },
    500 : {
      '0.3-0.4' : {1 : '3', 2 : '5', 4 : '9', 8 : '18', 10 : '23', 12 : '27', 14 : 'nelze', 18 : 'nelze', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '2', 8 : '4', 10 : '5', 12 : '6', 14 : '7', 18 : '8', 20 : '9'},
    },
    750 : {
      '0.3-0.4' : {1 : '2', 2 : '3', 4 : '6', 8 : '12', 10 : '15', 12 : '18', 14 : '21', 18 : '27', 20 : 'nelze'},
      '0.6' : {1 : '2', 2 : '2', 4 : '2', 8 : '3', 10 : '3', 12 : '4', 14 : '5', 18 : '6', 20 : '6'},
    },
    1000 : {
      '0.3-0.4' : {1 : '2', 2 : '3', 4 : '5', 8 : '9', 10 : '12', 12 : '14', 14 : '16', 18 : '20', 20 : '23'},
      '0.6' : {1 : '2', 2 : '2', 4 : '2', 8 : '2', 10 : '3', 12 : '3', 14 : '4', 18 : '4', 20 : '5'},
    },
  },
};